import { gql } from '@apollo/client';

export const FETCH_ACTION_LOG = gql`
	query getActionLog($rideId: ID!) {
		getWorkAssignmentActionLogByRideId(rideId: $rideId) {
			id
			type
			version
			crewMemberName
			crewMemberId
			defaultMessage
			createdAt
			createdBy
			parameters {
				__typename
				... on WorkAssignmentCreatedLog {
					activityType
					stationFrom
					stationTo
					status
					fromTimestamp
					toTimestamp
					timezone
					disregardedEligibilityRules
				}
				... on WorkAssignmentActualCreatedLog {
					activityType
					stationFrom
					stationTo
					fromTimestamp
					toTimestamp
					timezone
					reason
				}
				... on WorkAssignmentStatusUpdatedLog {
					activityType
					stationFrom
					stationTo
					fromTimestamp
					toTimestamp
					timezone
					reason
					oldStatus
					newStatus
				}
				... on WorkAssignmentTimeUpdatedLog {
					activityType
					status
					oldFromTime
					oldToTime
					newFromTime
					newToTime
					timezone
					stationFrom
					stationTo
					fromTimestamp
					toTimestamp
					reason
				}
				... on WorkAssignmentBreakdownLog {
					activityType
					stationFrom
					stationTo
					fromTimestamp
					toTimestamp
					timezone
					reason
					note
				}
			}
		}
	}
`;
